import { useEffect, useState } from 'react'

// Tracks whether the viewport is narrower than `width` px. Returns false
// during SSR and the first client render, then syncs to the real viewport.
export function useViewportBelow(width: number): boolean {
  const [below, setBelow] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${width - 1}px)`)
    const onChange = () => setBelow(mql.matches)
    mql.addEventListener('change', onChange)
    setBelow(mql.matches)
    return () => mql.removeEventListener('change', onChange)
  }, [width])

  return below
}
